import styled from '@emotion/styled'

export const DetailContainer = styled.div({
  display: 'flex',
})

export const Cont = styled.div(props => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
}))

export const SContDetail = styled.div(props => ({
  display: 'flex',
  marginTop: props.sub ? '0' : '1rem',

  '&>div:first-child': {
    marginLeft: 0,
    flex: 1
  },

  '>div:first-child .toleft': {
    marginLeft: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },

  '&>div': {
    marginLeft: '1rem',
    flex: 1
  }
}))
